module.exports = __webpack_public_path__ + "img/reward_reach_01.2dfd0163.png";